import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DataService } from "../core/services/data.service";
import { CouponSearchModel } from "../features/issue-coupon/coupon-search-model";
import { CouponInfo } from "../models/coupons/coupon-info";

@Injectable({
  providedIn: "root"
})
export class CouponService {
  private serviceUrl = "Coupon";

  constructor(private http: DataService) {}

  //todo: move to clearline-api
  searchCoupon(filter: CouponSearchModel): Observable<Array<CouponInfo>> {
    return this.http.get(`${this.serviceUrl}/search`, filter);
  }
}
